import AbstractAsset from './AbstractAsset';
import BannerConfig from '@structure/Configuration/BannerConfig';
import BannerName from './BannerName';
import { UapInfo } from '@/types';
import { ESPN_UAP_SIZE_MAPPING } from '@/support';
import Showcase from './Showcase';

export default class Banner extends AbstractAsset {
  protected configuration!: BannerConfig;

  public isBanner(): boolean {
    return true;
  }

  public isStatic(): boolean {
    return this.info().type === 'static';
  }

  public isHtml5(): boolean {
    return !this.isStatic();
  }

  public isCompressed(): boolean {
    return /\.zip$/i.test(this.info().basename);
  }

  /**
   * Is the banner in a folder starting with ESP? If so we will assume it's an
   * ESPN banner.
   */
  public isForEspn(): boolean {
    let directory = this.parent();

    while (directory) {
      if (/^ESPN?\d/.test(directory.basename())) {
        return true;
      }

      directory = directory.parent();
    }

    return false;
  }

  /**
   * Is the banner a UAP banner? This means it meets specific size requirements
   */
  public isEspnUap() {
    if (!this.isHtml5()) {
      return false;
    }

    if (!this.isForEspn()) {
      return false;
    }

    return this.espnUapInfo() !== undefined;
  }

  public espnUapInfo(): UapInfo | undefined {
    return ESPN_UAP_SIZE_MAPPING.find(
      size => size.width === this.width() && size.height === this.height()
    );
  }

  public showcase(): Showcase | null {
    if (!this.config().showcase()) {
      return null;
    }

    return new Showcase(this.config().showcase(), this);
  }

  public name(): string {
    return new BannerName(this, super.name()).toString();
  }

  public config(): BannerConfig {
    if (this.configuration) {
      return this.configuration;
    }

    return (this.configuration = new BannerConfig(
      this.resource.config || {},
      this.directory().config()
    ));
  }
}
